// import package and components
import React, { Component, useState, Suspense, lazy } from 'react';
import './App.css';
import './custom.css';
import './css/style.css'
// import 'react-toastify/dist/ReactToastify.css';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import RouteChangeLoader from './Utils/loader'; // now includes both loader logic and listener
import IsAuthenticat from './IsAuthenticat';
import Home from './Pages/home';
import OneApf from './Pages/OneApf';
import { DndProvider } from "react-dnd";
import { TouchBackend } from "react-dnd-touch-backend";
import { HTML5Backend } from "react-dnd-html5-backend";
import { isMobile } from "react-device-detect";
import { io } from 'socket.io-client';
import Constant from './Components/Constant';
import AdminAccess from './AdminAccess';
import getApiCall from './Services/getApiCall';
import { decryptBody } from './Services/helpers';
import Header from './Layout/topheader';
import Layout from './Layout';
import AutoLogout from './Autologout/autoLogout';
import ScrollToTop from './Components/ScrollToTop'; 
import {userDetails } from './Services/authenticationService';
import { selectedPartnerDetails } from './Services/authenticationService';
import ChatBot from './Utils/ChatBot';
import NESLGenerateLinkForm from './Components/NESLGenerateLinkForm';
import LoginPage from './Components/LoginPage';
import RedirectToLogin from './RedirectToLogin';
import PartnerGuard from './PartnerGuard';

// Lazy-loaded pages/components
const WebsiteBuilder = lazy(() => import("./Pages/WebsiteBuilder"));
const Login = lazy(() => import("./Components/Login"));
const AmenitiesManagement = lazy(() => import("./Components/Amenities/AmenitiesManagement"));
const AddAmenities = lazy(() => import("./Components/Amenities/AddUpdate"));
const PropertyTypeListing = lazy(() => import("./Pages/PropertyType/PropertyTypeListing"));
const PropertyTypeAdd = lazy(() => import("./Pages/PropertyType/PropertyTypeAdd"));
const CategoryListing = lazy(() => import("./Pages/Categories/CategoryListing"));
const CategoryAdd = lazy(() => import("./Pages/Categories/CategoryAdd"));
const BlogListing = lazy(() => import("./Pages/Blogs/BlogListing"));
const BlogCreate = lazy(() => import("./Pages/Blogs/BlogCreate"));
const PropertyListing = lazy(() => import("./Pages/Properties/PropertyListing"));
const PropertyAdd = lazy(() => import("./Pages/Properties/PropertyAdd"));
const StateListing = lazy(() => import("./Pages/States/StateListing"));
const StateAdd = lazy(() => import("./Pages/States/StateAdd"));
const CityListing = lazy(() => import("./Pages/City/CityListing"));
const CityAdd = lazy(() => import("./Pages/City/CityAdd"));
const PartnerManagement = lazy(() => import("./Pages/Partner/DataManagement"));
const AddUpdatePartner = lazy(() => import("./Pages/Partner/AddUpdate"));
const AddUserPartner = lazy(() => import("./Pages/Partner/AddUserPartner"));
const UserPartnerManagement = lazy(() => import("./Pages/Partner/UserPartnerManagement"));
const UpdateUserPartner = lazy(() => import("./Pages/Partner/UpdateUserPartner"));
const PartnerAdd = lazy(() => import("./Pages/Partner/PartnerAdd"));
const Permission = lazy(() => import('./Pages/Partner/Permission'));
const Role = lazy(() => import('./Pages/Partner/Role'));
const partnerAuditTrails = lazy(() => import('./Pages/Partner/AuditTrail'));

const FaqAdd = lazy(() => import("./Pages/Faqs/FaqAdd"));
const FaqsListing = lazy(() => import("./Pages/Faqs/FaqsListing"));
const FaqsCategoryListing = lazy(() => import("./Pages/FaqsCategory/FaqsCategoryListing"));
const FaqsCategoryCreate = lazy(() => import("./Pages/FaqsCategory/FaqsCategoryCreate"));

const CustomerListing = lazy(() => import("./Pages/Customer/CustomerListing"));
const CustomerAdd = lazy(() => import("./Pages/Customer/CustomerAdd"));

const CmsListing = lazy(() => import("./Pages/cms/CmsListing"));
const CmsAdd = lazy(() => import("./Pages/cms/CmsAdd"));

const BlogCategoryListing = lazy(() => import("./Pages/BlogCategory/BlogCategoryListing"));
const BlogCategoryCreate = lazy(() => import("./Pages/BlogCategory/BlogCategoryCreate"));

const PropertyBulkUpload = lazy(() => import("./Pages/Properties/PropertyBulkUpload"));
const PropertyAuctionBulkUpload = lazy(() => import("./Pages/Properties/PropertyAuctionBulkUpload"));
const PropertyAuctionAdd = lazy(() => import("./Pages/Properties/PropertyAuctionAdd"));
const PropertyBulkUpdate = lazy(() => import("./Pages/Properties/PropertyBulkUpdate"));
const PropertyDetails = lazy(() => import("./Pages/Properties/PropertyDetails"));
const PropertyDetailsForm = lazy(() => import("./Pages/Properties/PropertyDetailsForm"));
const PropertyFeedbacks = lazy(() => import("./Pages/Properties/PropertyFeedbacks"));
const AuctionPropertyListing = lazy(() => import('./Pages/Properties/AuctionPropertyListing'));
const AuditTrails = lazy(() => import('./Pages/Properties/AuditTrail'));

const PropertyBids = lazy(() => import("./Pages/Properties/PropertyBids"));
const PropertyManagement = lazy(() => import('./Pages/Bidder/PropertyMediaManagement/Property_Managemet'));
const Access_Property = lazy(() => import('./Pages/Bidder/PropertyMediaManagement/Access_Property'));
const MediaListing = lazy(() => import('./Pages/Bidder/PropertyMediaManagement/MediaListing'));
const MediaDetails = lazy(() => import('./Pages/Bidder/PropertyMediaManagement/MediaDetails'));

const LeadsListing = lazy(() => import("./Pages/Lead/LeadsListing"));
const LeadsAdd = lazy(() => import("./Pages/Lead/LeadsAdd"));
const LeadsUserPreference = lazy(() => import('./Pages/Lead/LeadsUserPreference'));
const LeadCommunications = lazy(() => import('./Pages/Lead/LeadCommunications'));
const LeadComments = lazy(() => import("./Pages/Lead/LeadComments"));

const PLanAdd = lazy(() => import("./Pages/plans/PlanAdd"));
const PlanListing = lazy(() => import("./Pages/plans/PlanListing"));

const BidderListing = lazy(() => import("./Pages/Bidder/BidderListing"));
const BidderDetial = lazy(() => import("./Pages/Bidder/BidderDetial"));
const PrimaryDetails = lazy(() => import('./Pages/Bidder/PrimaryDetails'));
const DocumentDetails = lazy(() => import('./Pages/Bidder/DocumentDetails'));
const PaymentDetails = lazy(() => import('./Pages/Bidder/PaymentDetails'));
const DeclarativeDocuments = lazy(() => import('./Pages/Bidder/DeclarativeDocument'));
const BidderProperties = lazy(() => import("./Pages/Bidder/BidderProperties"));
const PaymentVerification = lazy(() => import("./Pages/Bidder/PaymentVerification"));
const BidderOverview = lazy(() => import('./Pages/Bidder/BidderOverview'));
const BidderAddForm = lazy(() => import('./Pages/Bidder/BidderAdd'));
const BulkUploadPayment = lazy(() => import('./Pages/Bidder/BulkUploadPayment'));
const DocumentReviewScreen = lazy(() => import('./Pages/Bidder/DocumentReviewScreen'));

const BulkImageUpload = lazy(() => import('./Pages/Properties/BulklImageUpload'));
const BulkDocumentUpload = lazy(() => import('./Pages/Properties/BulkDocumentUpload'));

const LiveBid = lazy(() => import("./Pages/LiveBid/LiveBid"));
const PropertyDetail = lazy(() => import('./Pages/LiveBid/PropertyDetail'));
const LiveBidderList = lazy(() => import("./Pages/LiveBid/LiveBidderList"));

const AddressLocationListing = lazy(() => import("./Pages/AddressLocation/AddressLocationListing"));
const AddressLocationAdd = lazy(() => import("./Pages/AddressLocation/AddAddressLocation"));

const EmdPayments = lazy(() => import("./Pages/EmdPayment/EmdPaymentList"));

const NotificationListing = lazy(() => import('./Pages/NotificationManagement/NotificationListing'));
const NotificationSetting = lazy(() => import('./Pages/NotificationManagement/NotificationSetting'));
const NotificationCreateUpdate = lazy(() => import('./Pages/NotificationManagement/NotificationCreateUpdate'));

const FormBuilder = lazy(() => import('./Pages/FormBuilder/FormBuilder'));
const FormListing = lazy(() => import('./Pages/FormBuilder/FormListing'));
const CreateUpdateForms = lazy(() => import('./Pages/FormBuilder/CreateUpdateForms'));
const FormInsertdTable = lazy(() => import('./Pages/FormBuilder/FormInsertedTable'));
const BulkDataUpload = lazy(() => import('./Pages/FormBuilder/BulkDataUpload'));
const FormBuilderAuditLog = lazy(() => import("./Pages/FormBuilder/FormAuditTrail"));
const FormBuilderLevelAuditLog = lazy(() => import("./Pages/FormBuilder/FormLevelAuditTrail"));
const QueryManagement = lazy(() => import("./Pages/FormBuilder/QueryManagement"));

const OutputWebsitePage = lazy(() => import('./Pages/WebsiteBuilder/OutputWebsitePage'));

const TDSReviewListing = lazy(() => import('./Pages/TDS/tdsReviewListing'));

const ErrorPage = lazy(() => import('./Pages/ErrorPage'));
const PreLogin = lazy(() => import("./Components/pre-login/PreLogin"));
const WebBuilderList = lazy(() => import("./Pages/WebsiteBuilder/WebSiteBuilderList"));
const WebBuilderCreateUpdate = lazy(() => import("./Pages/WebsiteBuilder/WebSiteCreateUpdate"));
const WebBuilderPreview = lazy(() => import("./Pages/WebsiteBuilder/WebSiteBuilderPreview"));
const WorkflowListing = lazy(() => import("./Pages/WorkFlow/workflowListing"));
const WorkflowCanvas = lazy(() => import("./Pages/WorkFlow/WorkflowCanvas"));
const WorkflowTabs = lazy(() => import("./Pages/WorkFlow/WorkFlowTabs"));
const WorkflowAuditTrail = lazy(() => import("./Pages/WorkFlow/WorkflowAuditTrail"));

const NotificationList = lazy(() => import("./Pages/Tasks/NotificationList"));
const MyPendingTaskList = lazy(() => import("./Pages/Tasks/MyPendingTask"));

const CopyPaymentPlans = lazy(() => import("./Pages/FormBuilder/DataEntryOneAPF/PaymentPlans/CopyPaymentPlans"));
const ManagePlans = lazy(() => import("./Pages/FormBuilder/DataEntryOneAPF/PaymentPlans/ManagePlans"));
const CreatePaymentPlan = lazy(() => import("./Pages/FormBuilder/DataEntryOneAPF/PaymentPlans/CreatePaymentPlan"));
const PaymentPlanSelection = lazy(() => import("./Pages/FormBuilder/DataEntryOneAPF/PaymentPlans/PaymentPlanSelection"));
const AddProjectProgress = lazy(() => import("./Pages/FormBuilder/DataEntryOneAPF/ProjectProgress/AddProjectProgress"));
const BulkUpdateProjectProgress = lazy(() => import("./Pages/FormBuilder/DataEntryOneAPF/ProjectProgress/BulkUpdate"));
const ProjectProgressGroup = lazy(() => import("./Pages/FormBuilder/DataEntryOneAPF/ProjectProgress/BulkUpdate/ProjectProgressGroup"));
const OverAllProjectProgress = lazy(() => import("./Pages/FormBuilder/DataEntryOneAPF/ProjectProgress/OverAllProjectProgress/index"));
const ForumForm = lazy(() => import("./Pages/Forum/ForumForm"));
const ForumList = lazy(() => import("./Pages/Forum/ForumList"));
const WorkFlowData = lazy(() => import("./Pages/WorkFlow/WorkFlowDataTable"));
const WorkFlowFormRender = lazy(() => import("./Pages/WorkFlow/WorkFlowFormRender"));

class App extends Component {

    // run on first render
    state = {
        time: 'fetching',
        socket: io(Constant.socketPath,{
      transports: ["websocket"], // force WebSocket
      forceNew: true,            // prevent reusing old sessions
      reconnection: true,        // auto-reconnect
      reconnectionAttempts: 5,   // retry 5 times
    //   reconnectionDelay: 2000    // wait 2s between retries
    }),
     permissions: []   // ✅ added
    }


    // Do Not remove its used for Blob File Token
    componentDidMount() {
        console.log('IsAuthenticat()::::',IsAuthenticat())
        if(!localStorage.getItem('uploadT')){
        getApiCall('common/upload/blob/token')
            .then(response => {
                localStorage.setItem('uploadT', decryptBody(response.data).token)
            })
        }

        // ✅ fetch permissions here
        if (IsAuthenticat()) {
            this.loadPermissions();
        }
    }

    // ✅ New method
    // loadPermissions = async () => {
    //     const userDetailsData = userDetails();
    //     const url = `admin/modules/list/${userDetailsData?.id}/${userDetailsData?.partnerDetails[0]?._id}/${userDetailsData?.roles?._id}`;
    //     const data = await getApiCall(url);

    //     this.setState({ permissions: data.data });
    // };
     loadPermissions = async () => {
        const userDetailsData = userDetails();
        const selectedPartnerData = selectedPartnerDetails();
        let url='';
        if (selectedPartnerData?._id) {
             url = `admin/modules/list/${userDetailsData?.id}/${selectedPartnerData?._id}/${selectedPartnerData?.roleId}`;
        }else{
             url = `admin/modules/list/${userDetailsData?.id}/${userDetailsData?.partnerDetails[0]?._id}/${userDetailsData?.roles?._id}`;
        }
        const data = await getApiCall(url);

        this.setState({ permissions: data.data });
    };

    


    render() {
        const { socket, permissions,loadPermissions  } = this.state;
        // Hide header on login page
       

        return (
            <Router>

                    <Header moduleList = {permissions}/>
                {IsAuthenticat() ? (<>
                    <RouteChangeLoader />
                    <ScrollToTop />
                    <DefaultContainer socket={socket} permission = {permissions} loadPermissions={loadPermissions} />
                <AutoLogout excludedPaths={[]} />
                {/* <ChatBot /> */}

                </>)
                    : <Routes>
                        {/* <Route path="/:partner/" element={<PreLogin/>} /> */}
                        <Route path="/" element={<LoginPage/>} replace/>
                        <Route path="/nesl-generate-link" element={<NESLGenerateLinkForm/>}/>
                       {/* <Route path="*" element={<Navigate to="/" replace />} /> */}
                        <Route
                            path="*"
                            element={<RedirectToLogin />}
                        />
                    </Routes>
                }

            </Router>
        );
    }

}


//To be change in to default router
const DefaultContainer = (props) =>
(
    <DndProvider backend={isMobile ? TouchBackend : HTML5Backend}>
        <Layout permissions={props.permission}>
            <Suspense fallback={<div>Loading...</div>}>

                <Routes>
                    <Route element={<PartnerGuard />}>
                    {/* Public Routes */}
                    {/* <Route path="/:partner/" element={<Navigate to={"/home"} replace />} /> */}
                        <Route
                            path="/:partner/"
                            element={<Navigate to="../all-modules" replace />}
                        />

                    {/* Admin/Protected Routes */}
                    {/* <Route path="/:partner/home" element={<AdminAccess><Home permissions={props.permission} getModuleData={props.loadPermissions} /></AdminAccess>} /> */}
                        {/* <Route
                            path="/:partner/home"
                            element={
                                <AdminAccess>
                                    <Home
                                        permissions={props.permission}
                                        getModuleData={props.loadPermissions}
                                    />
                                </AdminAccess>
                            }
                        /> */}

                        <Route
                            path="/:partner/:folder"
                            element={
                                <AdminAccess>
                                    <Home
                                        permissions={props.permission}
                                        getModuleData={props.loadPermissions}
                                    />
                                </AdminAccess>
                            }
                        />
                    <Route path="/:partner/home/one-apf" element={<AdminAccess><OneApf permissions={props.permission} /></AdminAccess>} />
                    <Route path="/:partner/home/one-apf/:formName/:formId" element={<AdminAccess><OneApf permissions={props.permission} /></AdminAccess>} />
                    <Route path="/:partner/WebsiteBuilder" element={<AdminAccess><WebsiteBuilder /></AdminAccess>} />
                    <Route path="/:partner/amenities" element={<AdminAccess><AmenitiesManagement /></AdminAccess>} />
                    <Route path="/:partner/amenities/add" element={<AdminAccess><AddAmenities /></AdminAccess>} />
                    <Route path="/:partner/customers" element={<AdminAccess><CustomerListing /></AdminAccess>} />
                    <Route path="/:partner/customers/add" element={<AdminAccess><CustomerAdd /></AdminAccess>} />
                    <Route path="/:partner/property-types" element={<AdminAccess><PropertyTypeListing /></AdminAccess>} />
                    <Route path="/:partner/property-types/add" element={<AdminAccess><PropertyTypeAdd /></AdminAccess>} />
                    <Route path="/:partner/properties" element={<AdminAccess><PropertyListing /></AdminAccess>} />
                    <Route path="/:partner/properties/auction" element={<AdminAccess><AuctionPropertyListing /></AdminAccess>} />
                    <Route path="/:partner/property/add" element={<AdminAccess><PropertyAdd /></AdminAccess>} />
                    <Route path="/:partner/property/details/:id" element={<AdminAccess><PropertyDetails /></AdminAccess>} />
                    <Route path="/:partner/property/auction/add" element={<AdminAccess><PropertyAuctionAdd /></AdminAccess>} />
                    <Route path="/:partner/properties/bids/:id" element={<AdminAccess><PropertyBids /></AdminAccess>} />
                    <Route path="/:partner/properties/feedbacks/:id" element={<AdminAccess><PropertyFeedbacks /></AdminAccess>} />
                    <Route path="/:partner/properties/feedbacks" element={<AdminAccess><PropertyFeedbacks /></AdminAccess>} />
                    <Route path="/:partner/properties/audit-trails/:id" element={<AdminAccess><AuditTrails /></AdminAccess>} />
                    <Route path="/:partner/properties/bulk-update" element={<AdminAccess><PropertyBulkUpdate /></AdminAccess>} />
                    <Route path="/:partner/property/bulk-upload" element={<AdminAccess><PropertyBulkUpload /></AdminAccess>} />
                    <Route path="/:partner/property/auction-bulk-upload" element={<AdminAccess><PropertyAuctionBulkUpload /></AdminAccess>} />
                    <Route path="/:partner/property/bulk-image-upload" element={<AdminAccess><BulkImageUpload /></AdminAccess>} />
                    <Route path="/:partner/property/bulk-doucument-upload" element={<AdminAccess><BulkDocumentUpload /></AdminAccess>} />
                    <Route path="/:partner/properties/upload_media" element={<AdminAccess><PropertyManagement /></AdminAccess>} />
                    <Route path="/:partner/properties/access_media" element={<AdminAccess><MediaListing /></AdminAccess>} />
                    <Route path="/:partner/properties/media_list" element={<AdminAccess><MediaListing /></AdminAccess>} />
                    <Route path="/:partner/property/media_detail/:id" element={<AdminAccess><MediaDetails /></AdminAccess>} />
                    <Route path="/:partner/leads" element={<AdminAccess><LeadsListing /></AdminAccess>} />
                    <Route path="/:partner/leads_preference" element={<AdminAccess><LeadsUserPreference /></AdminAccess>} />
                    <Route path="/:partner/leads_communications" element={<AdminAccess><LeadCommunications /></AdminAccess>} />
                    <Route path="/:partner/states" element={<AdminAccess><StateListing /></AdminAccess>} />
                    <Route path="/:partner/cities" element={<AdminAccess><CityListing /></AdminAccess>} />
                    <Route path="/:partner/edit-city/:id" element={<AdminAccess><CityAdd /></AdminAccess>} />
                    <Route path="/:partner/add-city" element={<AdminAccess><CityAdd /></AdminAccess>} />
                    <Route path="/:partner/states/add" element={<AdminAccess><StateAdd /></AdminAccess>} />
                    <Route path="/:partner/address-locations" element={<AdminAccess><AddressLocationListing /></AdminAccess>} />
                    <Route path="/:partner/address-locations/add" element={<AdminAccess><AddressLocationAdd /></AdminAccess>} />
                    <Route path="/:partner/address-locations/edit/:id" element={<AdminAccess><AddressLocationAdd /></AdminAccess>} />
                    <Route path="/:partner/categories" element={<AdminAccess><CategoryListing /></AdminAccess>} />
                    <Route path="/:partner/categories/add" element={<AdminAccess><CategoryAdd /></AdminAccess>} />
                    <Route path="/:partner/blogs" element={<AdminAccess><BlogListing /></AdminAccess>} />
                    <Route path="/:partner/blogs/add" element={<AdminAccess><BlogCreate /></AdminAccess>} />
                    <Route path="/:partner/blogs/blogs/add?" element={<AdminAccess><BlogCreate /></AdminAccess>} />
                    <Route path="/:partner/blogs/categories" element={<AdminAccess><BlogCategoryListing /></AdminAccess>} />
                    <Route path="/:partner/blogs/categories/add" element={<AdminAccess><BlogCategoryCreate /></AdminAccess>} />
                    <Route path="/:partner/cms" element={<AdminAccess><CmsListing /></AdminAccess>} />
                    <Route path="/:partner/cms/add" element={<AdminAccess><CmsAdd /></AdminAccess>} />
                    <Route path="/:partner/partner-management" element={<AdminAccess><PartnerManagement /></AdminAccess>} />
                    <Route path="/:partner/Permission/:id" element={<AdminAccess><Permission /></AdminAccess>} />
                    <Route path="/:partner/create-partner" element={<AdminAccess><AddUpdatePartner /></AdminAccess>} />
                    <Route path="/:partner/edit-partner/:id" element={<AdminAccess><AddUpdatePartner /></AdminAccess>} />
                    <Route path="/:partner/partner-users/:id/:name" element={<AdminAccess><UserPartnerManagement /></AdminAccess>} />
                    <Route path="/:partner/add-user-partner/:id/:name" element={<AdminAccess><AddUserPartner /></AdminAccess>} />
                    <Route path="/:partner/edit-user-partner/:id" element={<AdminAccess><UpdateUserPartner /></AdminAccess>} />
                    <Route path="/:partner/role/:id/:role" element={<AdminAccess><Role /></AdminAccess>} />
                    <Route path="/:partner/partner-user-audit-trail/:id" element={<AdminAccess><partnerAuditTrails /></AdminAccess>} />
                    {/* FAQs */}
                    <Route path="/:partner/faqs" element={<AdminAccess><FaqsListing /></AdminAccess>} />
                    <Route path="/:partner/faqs/addFaqs" element={<AdminAccess><FaqAdd /></AdminAccess>} />
                    <Route path="/:partner/faqs/editFaqs/:id" element={<AdminAccess><FaqAdd /></AdminAccess>} />
                    <Route path="/:partner/faqs/categories" element={<AdminAccess><FaqsCategoryListing /></AdminAccess>} />
                    <Route path="/:partner/faqs/categories/add" element={<AdminAccess><FaqsCategoryCreate /></AdminAccess>} />

                    {/* Plans */}
                    <Route path="/:partner/plans" element={<AdminAccess><PlanListing /></AdminAccess>} />
                    <Route path="/:partner/plans/add" element={<AdminAccess><PLanAdd /></AdminAccess>} />

                    {/* Bidders */}
                    <Route path="/:partner/bidders/detail/:id" element={<AdminAccess><BidderDetial /></AdminAccess>} />
                    <Route path="/:partner/bidder/add" element={<AdminAccess><BidderAddForm /></AdminAccess>} />
                    <Route path="/:partner/bidders" element={<AdminAccess><BidderListing /></AdminAccess>} />
                    <Route path="/:partner/bidder/bidder_overviews/:participationId" element={<AdminAccess><BidderOverview /></AdminAccess>} />
                    <Route path="/:partner/bidders/properties/:bidderId" element={<AdminAccess><BidderProperties /></AdminAccess>} />
                    <Route path="/:partner/live_bid" element={<AdminAccess socket={props.socket}><LiveBid /></AdminAccess>} />
                    <Route path="/:partner/Property_Details/:id" element={<AdminAccess socket={props.socket}><PropertyDetail /></AdminAccess>} />
                    <Route path="/:partner/Leads_Comments/:id" element={<AdminAccess><LeadComments /></AdminAccess>} />
                    <Route path="/:partner/liveBidderList/:id" element={<AdminAccess socket={props.socket}><LiveBidderList /></AdminAccess>} />

                    {/* Primary, Document, Payment Details */}
                    <Route path="/:partner/Primary_Details/:id" element={<AdminAccess><PrimaryDetails /></AdminAccess>} />
                    <Route path="/:partner/Document_Details/:id" element={<AdminAccess><DocumentDetails /></AdminAccess>} />
                    <Route path="/:partner/Payment_Details/:id" element={<AdminAccess><PaymentDetails /></AdminAccess>} />
                    <Route path="/:partner/Payment_Verification/:id" element={<AdminAccess><PaymentVerification /></AdminAccess>} />
                    <Route path="/:partner/Declarative_Documents/:id" element={<AdminAccess><DeclarativeDocuments /></AdminAccess>} />
                    <Route path="/:partner/emd-payments" element={<AdminAccess><EmdPayments /></AdminAccess>} />

                    {/* Notifications */}
                    <Route path="/:partner/notification-management" element={<AdminAccess><NotificationListing /></AdminAccess>} />
                    <Route path="/:partner/notification-settings/:partnerId" element={<AdminAccess><NotificationSetting /></AdminAccess>} />
                    <Route path="/:partner/create-update-notification" element={<AdminAccess><NotificationCreateUpdate /></AdminAccess>} />

                    {/* Forms */}
                    <Route path="/:partner/form-builder" element={<AdminAccess><FormBuilder /></AdminAccess>} />
                    <Route path="/:partner/form-builder/:formId" element={<AdminAccess><FormBuilder /></AdminAccess>} />
                    <Route path="/:partner/form-listing" element={<AdminAccess><FormListing /></AdminAccess>} />
                    <Route path="/:partner/form-builder/audit-trail/:formName/:formId" element={<AdminAccess><FormBuilderLevelAuditLog /></AdminAccess>} />
                    <Route path="/:partner/forms-list/:formName/:formId" element={<AdminAccess><FormInsertdTable /></AdminAccess>} />
                    <Route path="/:partner/create-update-from/:formName/:formId/:type" element={<AdminAccess><CreateUpdateForms /></AdminAccess>} />
                    <Route path="/:partner/tds-review-listing" element={<AdminAccess><TDSReviewListing /></AdminAccess>} />
                    <Route path="/:partner/tds_review/:id" element={<AdminAccess><DocumentReviewScreen /></AdminAccess>} />
                    <Route path="/:partner/formData/bulk-upload/:formName/:type/:formId" element={<AdminAccess><BulkDataUpload /></AdminAccess>} />
                    <Route path="/:partner/formData/audit-trails/:formName/:formId/:id" element={<AdminAccess><FormBuilderAuditLog /></AdminAccess>} />
                    <Route path="/:partner/formData/:formName/queries/:formId/:id" element={<AdminAccess><QueryManagement /></AdminAccess>} />

                    {/* Website & Payments */}
                    <Route path="/:partner/website/output" element={<AdminAccess><OutputWebsitePage /></AdminAccess>} />
                    <Route path="/:partner/payment/bulk-upload/:type" element={<AdminAccess><BulkUploadPayment /></AdminAccess>} />
                    <Route path="/:partner/website/list" element={<AdminAccess><WebBuilderList /></AdminAccess>} />
                    <Route path="/:partner/website/create-update-web-builder/:webId/:type" element={<AdminAccess><WebBuilderCreateUpdate /></AdminAccess>} />
                    <Route path="/:partner/website/create-update-web-builder/:type" element={<AdminAccess><WebBuilderCreateUpdate /></AdminAccess>} />
                    <Route path="/:partner/website/:webName" element={<AdminAccess><WebBuilderPreview /></AdminAccess>} />
                    {/* Continue with remaining routes in same pattern */}
                    <Route path="/:partner/workflow_listings" element={<AdminAccess><WorkflowListing /></AdminAccess>} />
                    <Route path="/:partner/workflow_design/:type" element={<AdminAccess><WorkflowCanvas /></AdminAccess>} />
                    <Route path="/:partner/workflow_data/:wofId" element={<AdminAccess><WorkFlowData /></AdminAccess>} />
                    <Route path="/:partner/workflow_form_render/:wofId/:instanceId" element={<AdminAccess><WorkFlowFormRender /></AdminAccess>} />
                    <Route path="/:partner/workflow_tabs/:wofId" element={<AdminAccess><WorkflowTabs permissions={props.permission} getModuleData={props.loadPermissions}/></AdminAccess>} />
                    <Route path="/:partner/workflow-audit/:workflowId" element={<AdminAccess><WorkflowAuditTrail /></AdminAccess>} />

                    <Route path="/:partner/notificationList" element={<AdminAccess><NotificationList /></AdminAccess>} />
                    <Route path="/:partner/my-tasks" element={<AdminAccess><MyPendingTaskList /></AdminAccess>} />

                    {/* ONE APF Data Entry Payment Plan*/}
                    <Route path="/:partner/copy-payment-plans" element={<AdminAccess><CopyPaymentPlans /></AdminAccess>} />
                    <Route path="/:partner/manage-payment-plans" element={<AdminAccess><ManagePlans /></AdminAccess>} />
                    <Route path="/:partner/selection-payment-plans" element={<AdminAccess><PaymentPlanSelection /></AdminAccess>} />
                    <Route path="/:partner/manage-payment-plans/:type" element={<AdminAccess><CreatePaymentPlan /></AdminAccess>} />
                    <Route path="/:partner/one-apf/project-progress/:type" element={<AdminAccess><AddProjectProgress /></AdminAccess>} />
                    <Route path="/:partner/one-apf/project-progress/bulk-update" element={<AdminAccess><BulkUpdateProjectProgress /></AdminAccess>} />
                    <Route path="/:partner/one-apf/project-progress/group" element={<AdminAccess><ProjectProgressGroup /></AdminAccess>} />
                    <Route path="/:partner/one-apf/project-progress/over-all-progress" element={<AdminAccess><OverAllProjectProgress /></AdminAccess>} />

                    <Route path="/:partner/user-assignment/forum-form" element={<AdminAccess><ForumForm /></AdminAccess>} />
                    <Route path="/:partner/user-assignment/forum-list" element={<AdminAccess><ForumList /></AdminAccess>} />

                    {/* Default redirect */}
                    {/* Catch-all 404 */}
                    <Route path="/:partner/page-not-found" element={<AdminAccess><ErrorPage /></AdminAccess>} />
                    <Route path="*" element={<ErrorPage />} />
                    </Route>
                </Routes>

            </Suspense>
        </Layout>
    </DndProvider>
)



export default App;